import { useEffect } from "react";
import { createPortal } from "react-dom";
import JsBarcode from "jsbarcode";
import { Button } from "./ui/button";
import { Printer, X } from "lucide-react";

export const BulkBarcodePrint = ({ devices, onClose }) => {
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        JsBarcode(".bulk-bc").init();
      } catch (e) {
        console.error("Bulk barcode render failed", e);
      }
    }, 150);
    return () => clearTimeout(t);
  }, [devices]);

  if (!devices) return null;

  return createPortal(
    <div className="bulk-print-root" data-testid="bulk-barcode-overlay">
      <style>{`
        .bulk-print-root {
          position: fixed;
          inset: 0;
          background: rgba(15, 15, 20, 0.6);
          z-index: 100;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow-y: auto;
          padding: 24px;
        }
        .bulk-toolbar {
          position: sticky;
          top: 0;
          z-index: 2;
          display: flex;
          gap: 8px;
          margin-bottom: 16px;
        }
        .bulk-labels {
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
        }
        .device-label-bulk {
          width: 60mm;
          height: 40mm;
          background: #fff;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: 4mm 3mm 2.5mm;
          direction: ltr;
          overflow: hidden;
        }
        .device-label-bulk .lbl-head { display: flex; flex-direction: column; align-items: center; gap: 0.8mm; justify-content: center; }
        .device-label-bulk .lbl-head img { height: 6mm; filter: brightness(0); }
        .device-label-bulk .lbl-head .brand { font-size: 7pt; font-weight: 700; color: #0A0A0A; letter-spacing: .4px; line-height: 1; text-align: center; }
        .device-label-bulk .lbl-name { font-size: 6.5pt; color: #0A0A0A; font-weight: 600; max-width: 54mm; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; }
        .device-label-bulk svg { max-width: 54mm; }
        .device-label-bulk .lbl-no { font-family: 'Courier New', monospace; font-size: 9pt; font-weight: 700; letter-spacing: 1.5px; color: #0A0A0A; }
        .device-label-bulk .lbl-serial { font-family: 'Courier New', monospace; font-size: 6.5pt; font-weight: 600; letter-spacing: 0.5px; color: #0A0A0A; max-width: 54mm; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1; }
        @media print {
          @page { size: 60mm 40mm; margin: 0; }
          #root { display: none !important; }
          html, body { width: 60mm !important; margin: 0 !important; padding: 0 !important; }
          /* Override the global App.css print rule (body * { visibility: hidden }) */
          .bulk-print-root, .bulk-print-root * { visibility: visible !important; }
          .bulk-print-root { position: static !important; background: none !important; padding: 0 !important; overflow: visible !important; display: block !important; }
          .bulk-toolbar { display: none !important; visibility: hidden !important; }
          .bulk-labels { display: block !important; }
          .device-label-bulk {
            border-radius: 0 !important;
            page-break-after: always;
            break-after: page;
            margin: 0 !important;
          }
          .device-label-bulk:last-child { page-break-after: auto; break-after: auto; }
        }
      `}</style>

      <div className="bulk-toolbar no-print">
        <Button onClick={() => window.print()} className="bg-[#655dc6] hover:bg-[#5449a8] text-white gap-2" data-testid="bulk-print-btn">
          <Printer className="w-4 h-4" /> طباعة الكل ({devices.length})
        </Button>
        <Button variant="outline" onClick={onClose} className="bg-white gap-1" data-testid="bulk-close-btn">
          <X className="w-4 h-4" /> إغلاق
        </Button>
      </div>

      <div className="bulk-labels">
        {devices.map((d) => (
          <div key={d.id} className="device-label-bulk">
            <div className="lbl-head">
              <img src="/lucent-logo.png" alt="Lucent" />
              <div className="brand">Lucent Dental Center Co.,</div>
            </div>
            <div className="lbl-name">{d.device_name}</div>
            <svg
              className="bulk-bc"
              jsbarcode-format="CODE128"
              jsbarcode-value={d.biomed_no}
              jsbarcode-displayvalue="false"
              jsbarcode-height="40"
              jsbarcode-width="1.6"
              jsbarcode-margin="0"
            ></svg>
            <div className="lbl-no">{d.biomed_no}</div>
            {(d.device_type === "electrical" || d.device_type === "electric") && d.serial_no && (
              <div className="lbl-serial">SN: {d.serial_no}</div>
            )}
          </div>
        ))}
      </div>
    </div>,
    document.body
  );
};
